import React, { FC, PropsWithChildren } from 'react';

import { AppState, Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router';

import { emitAuthPerfEvent } from 'src/hooks/usePerformanceTracking';

export const Auth0ProviderWithNavigate: FC<PropsWithChildren> = ({
  children,
}) => {
  const navigate = useNavigate();
  const domain = window.AUTH0_DOMAIN;
  const clientId = window.AUTH0_CLIENT_ID;
  const redirectUri = window.AUTH0_CALLBACK_URL;
  const audience = window.AUTH0_AUDIENCE;

  const onRedirectCallback = (appState: AppState | undefined) => {
    emitAuthPerfEvent();
    navigate(appState?.returnTo || window.location.pathname, { replace: true });
  };

  if (!(domain && clientId && redirectUri)) {
    return null;
  }

  return (
    <Auth0Provider
      useRefreshTokens
      authorizationParams={{
        redirect_uri: redirectUri,
        scope: 'email openid offline_access',
        screen_hint: 'login',
        audience,
      }}
      authorizeTimeoutInSeconds={120}
      cacheLocation="localstorage"
      clientId={clientId}
      domain={domain}
      httpTimeoutInSeconds={30}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
